export type SeverityLevel =
  | 'critical'
  | 'high'
  | 'medium'
  | 'low'
  | 'neutral'
  | 'confirmed_threat'
  | 'no_action_needed'
  | 'act_now'
  | 'watch'
  | 'monitor'

export function getSeverityClasses(level: string | null | undefined): {
  bg: string
  border: string
  text: string
  badge: string
} {
  const normalized = (level ?? '').toLowerCase()

  if (['critical', 'act_now', 'tier_1', 'confirmed_threat'].includes(normalized)) {
    return { bg: 'bg-red-50', border: 'border-red-200', text: 'text-red-800', badge: 'bg-red-100 text-red-700' }
  }
  if (['high', 'watch', 'tier_2'].includes(normalized)) {
    return { bg: 'bg-amber-50', border: 'border-amber-200', text: 'text-amber-800', badge: 'bg-amber-100 text-amber-700' }
  }
  if (['medium', 'monitor', 'tier_3', 'requires_manual_review'].includes(normalized)) {
    return { bg: 'bg-blue-50', border: 'border-blue-200', text: 'text-blue-800', badge: 'bg-blue-100 text-blue-700' }
  }
  if (['low', 'no_action_needed', 'all_clear', 'completed', 'done'].includes(normalized)) {
    return { bg: 'bg-emerald-50', border: 'border-emerald-200', text: 'text-emerald-800', badge: 'bg-emerald-100 text-emerald-700' }
  }

  return { bg: 'bg-slate-50', border: 'border-slate-200', text: 'text-slate-600', badge: 'bg-slate-100 text-slate-600' }
}
